/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 256
// module chunks = 0